import { CaptchaAction } from '.';
import { IFeature } from '..';

export interface RecaptchaVersionConfig extends IFeature {
    siteKey: string;
    allowedActions?: CaptchaAction[];
}
